<template>
    <div class="hypothec-bank-cards" v-if="bankCardsSet != null && bankCardsSet.length > 0">
        <div class="card-item" v-for="(item, index) in bankCardsSet">
            <div class="item-head">
                <div class="logo">
                    <div class="logo-pic">
                        <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + item.logoId" alt="" v-if="item.offline != true">
                        <img :src="item.logoBank" alt="" v-else>
                    </div>
                    <strong>{{ item.langValue1 }}</strong>
                </div>
                <button class="link-choose" v-if="item.offline != true" @click="linkToLogin(URLrocketLC + '/?apartment_id=' + appsID + '&city=' + complexCity + '&method=mortgage&bankname=' + getClearBankName(item.langValue1) + '&lang=' + langVAR, 'mortgage')">{{ flatsPage.on_hyp_btn_select }}</button>
                <!-- <a href="#" class="link-choose" v-if="item.offline != true">Выбрать</a> -->
            </div>
            <div class="hypothec-name" v-if="item.hypothecName != null"><h3>{{ item.hypothecName }}</h3></div>
            <div class="hpothec-params">
                <ul>
                    <li>
                        <span>{{flatsPage.on_hyp_word_stavka}}</span>
                        <strong>{{ item.mortgageTerms_Set[0].bet }} %</strong>
                    </li>
                    <li>
                        <span>{{ flatsPage.on_hyp_word_hyp_srok }}</span>
                        <strong>{{ creditYear }} {{ flatsPage.on_hyp_word_year }}</strong>
                    </li>
                    <li>
                        <span>{{ flatsPage.on_hyp_word_hyp_full_cost }}</span>
                        <strong>{{ getNumber(flatFullPrice) }} <svgIcon name="tenge" class="icon-tenge"/></strong>
                    </li>
                    <li>
                        <span v-if="formulaCurrent == 'annuitet'">{{ flatsPage.on_hyp_word_month_pay }}</span>
                        <span v-if="formulaCurrent != 'annuitet'">{{ flatsPage.on_hyp_word_middle_month_pay }}</span>
                        <strong class="pay-month">~ {{ getNumber(item.payMonth) }} <svgIcon name="tenge" class="icon-tenge"/></strong>
                    </li>
                </ul>
            </div>
            <!-- v-if="showFullInfo == index" -->
            <div class="full-info" >
                <ul>
                    <li>
                        <div class="info-label">{{ flatsPage.on_hyp_word_gcv }}</div>
                        <div class="info-value info-value-project">{{ item.EffectiveRate }} %</div>
                    </li>
                    <li>
                        <div class="info-label">{{ flatsPage.on_hyp_word_mortage_suda }}</div>
                        <div class="info-value">{{ getNumber(item.bankAmount) }} <svgIcon name="tenge" class="icon-tenge"/></div>
                    </li>
                    <li>
                        <div class="info-label">{{ flatsPage.on_hyp_word_overpay }}</div>
                        <div class="info-value">{{ getNumber(item.overBankAmount) }} <svgIcon name="tenge" class="icon-tenge"/></div>
                    </li>
                    <li>
                        <div class="info-label">{{ flatsPage.on_hyp_word_full_flat_cost }}</div>
                        <div class="info-value">{{ getNumber(item.totalFlatPrice) }} <svgIcon name="tenge" class="icon-tenge"/></div>
                    </li>
                </ul>
            </div>
            <!-- <div class="getFullInfo">
                <div @click="showFullInfo = index" v-if="showFullInfo != index" class="down">Расширенная информация <svgIcon name="arrow_drop" class="icon-arrow-down"/></div>
                <div @click="showFullInfo = null" v-if="showFullInfo == index" class="up">Свернуть <svgIcon name="arrow_drop" class="icon-arrow-down"/></div>
            </div> -->
        </div>
    </div>
</template>

<script>
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import {mapGetters} from 'vuex'
    export default {
        name: 'flat-crm-card-payment-hypothec-items',
        props: ['bankCardsSet', 'formulaCurrent', 'flatFullPrice', 'creditYear', 'complexCity', 'appsID'],
        components: {
            svgIcon,
        },
        data () {
            return {
                showFullInfo: null,
                langVAR: window.LangVar,
            }
        },
        computed: {
            ...mapGetters({
                flatsPage: 'loadFlatsPage',
                URLrocketLC: 'loadUrlRocketLC',
                isMobileChecker: 'loadIsMobileChecker',
            }),
        },
        methods: {
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ")
            },
            getClearBankName(name) {
                let clearName = name.replace(/[^a-zA-Z ]/g, '');
                let resultName = clearName.replace(/[^a-zA-Zа-яА-Я]/g, '').toLowerCase();
                return resultName;
                // console.log(clearName, resultName)
            },  
            linkToLogin(url, method) {
                // console.log(url);
                ym(57579163,'reachGoal','btn_select_hypothec_bank')
                var exist = localStorage.getItem('favorite_flats');
                exist = exist ? exist.split(',') : [];
                // var url = 'https://bazis-a.rocketfirm.net';
                var favoriteUrl;
                if (exist.length > 0) {
                    favoriteUrl = '&favoritesFlats=' + exist.join(',');
                    // console.log(exist, url + favoriteUrl);
                    window.open(
                        url + favoriteUrl,
                        '_blank'
                    );
                } else {
                    window.open(
                        url,
                        '_blank'
                    );
                }
            },
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-card-payment-hypothec-items.scss';
    // @import '@/styles/components/flats-crm/respond/flats-crm-card-payment-hypothec-respond.scss';
    // @import '@/styles/components/flats-page/flats-card.scss';
    // @import '@/styles/components/flats-page/respond/flats-card-respond.scss';
</style>